import { defineMessages } from '@jutro/locale';

export default defineMessages({
    DetailedSummary: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Detailed Summary',
        defaultMessage: 'Detailed Summary'
    },
    ClaimInformation: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Claim Information',
        defaultMessage: 'Claim Information'
    },
    ClaimNumber: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Claim #',
        defaultMessage: 'Claim #:'
    },
    ClaimDate: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Claim Date',
        defaultMessage: 'Claim Date:'
    },
    ClaimTime: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Claim Time',
        defaultMessage: 'Claim Time:'
    },
    ClaimStatus: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Claim Status',
        defaultMessage: 'Claim Status:'
    },
    Location: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Location',
        defaultMessage: 'Location'
    },
    Description: {
        id: 'ml.claim.views.ml-claim-details-detailed-summary.Description',
        defaultMessage: 'Description'
    }
});
